'use client';

import type { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import EditableMarkdownV2 from "@/app/features/shared/editable-markdown/EditableMarkdownV2";
import EditableTypographyV2 from "@/app/features/shared/editable-typography/EditableTypographyV2";
import ImageCarouselEditable from "@/app/features/shared/image-carusel/ui/editable/ImageCarusel.editable";
import {
    ShowroomContainerFrame,
    ShowroomHeaderFrame,
    ShowroomImageCarouselFrame,
} from "@/app/features/shared/showroom/ui/shared/ShowroomFrames.shared";

type ShowroomEditableData = {
    title: string;
    subtitle?: string | null;
    description?: string | null;
    images: MediaRef[];
};

interface ShowroomEditableProps {
    data: ShowroomEditableData;
    onTitleChange: (title: string) => void;
    onSubtitleChange: (subtitle: string) => void;
    onDescriptionChange: (description: string) => void;
    onImagesChange: (images: MediaRef[]) => void;
    reserveRightRail?: boolean;
    sectionId?: string;
}

export default function ShowroomEditable({
    data,
    onTitleChange,
    onSubtitleChange,
    onDescriptionChange,
    onImagesChange,
    reserveRightRail,
    sectionId,
}: ShowroomEditableProps) {
    const headingId = "showroom-heading";

    return (
        <ShowroomContainerFrame headingId={headingId} sectionId={sectionId}>
            <ShowroomHeaderFrame reserveRightRail={reserveRightRail}>
                <EditableTypographyV2
                    id={headingId}
                    label="Überschrift"
                    variant="h2"
                    color="var(--primary-readable, var(--primary))"
                    value={data.title}
                    onChange={onTitleChange}
                    required
                />
                <EditableTypographyV2
                    label="Untertitel"
                    variant="subtitle1"
                    value={data.subtitle ?? ""}
                    onChange={onSubtitleChange}
                />
                <EditableMarkdownV2
                    label="Beschreibung"
                    typographyOverrides={{ paragraph: "body1" }}
                    value={data.description ?? ""}
                    onChange={onDescriptionChange}
                />
            </ShowroomHeaderFrame>

            <ShowroomImageCarouselFrame reserveRightRail={reserveRightRail}>
                <ImageCarouselEditable images={data.images} onImagesChanged={onImagesChange} />
            </ShowroomImageCarouselFrame>
        </ShowroomContainerFrame>
    );
}
